export default __webpack_public_path__ + "static/media/phy_3.eb07d8b5.jpg";